import ComputerRoundedIcon from "@mui/icons-material/ComputerRounded";
import React from "react";
import { useLegacyBrowserPopup } from "../../../services/app-state";
import { colors } from "../../../utils/colors";
import { Notification } from "../Notification";

export const LegacyBrowserPopup = () => {
    const [{ isShowing }, { closeLegacyBrowserPopup }] = useLegacyBrowserPopup();

    return (
        <Notification
            icon={<ComputerRoundedIcon fontSize="large" htmlColor={colors.brandDark} />}
            isVisible={isShowing}
            title={"Unsupprted browser"}
            content={
                "Your web browser is out of date. We recommend accessing Headstart via Chrome or Safari."
            }
            onConfirm={closeLegacyBrowserPopup}
        />
    );
};
